/** @jsx jsx */
import { SyntheticEvent } from 'react';
import Icon from '@zapier/common-components/src/components/Icon';
import Link from '@zapier/common-components/src/components/Link';
import { css, jsx } from '@emotion/core';

type Props = {
  crumbs: Array<{
    /** Text to display for a crumb */
    text: string;
    /** Should a crumb be disabled */
    disabled?: boolean;
    /** URL of a crumb */
    url?: string;
    /** Callback when a crumb is clicked */
    onClick?: (e: SyntheticEvent<HTMLElement>) => void;
  }>;
};

const breadcrumbCss = css({
  display: 'block',
});

const crumbsCss = css({
  display: 'flex',
  flexWrap: 'wrap',
  listStyle: 'none',
  marginBottom: '0.7em',
});

const iconCss = css({
  marginLeft: '.3em',
  marginRight: '.3em',
});

const Breadcrumb = (props: Props) =>
  !!props.crumbs.length && (
    <nav css={[breadcrumbCss]}>
      <ol css={crumbsCss}>
        {props.crumbs.map(({ text, url, disabled, onClick }, index) => (
          <li key={index}>
            {index > 0 && <Icon css={iconCss} name="arrow-right" size={12} />}
            {(url || onClick) && !disabled ? (
              <Link href={url} onClick={onClick}>
                {text}
              </Link>
            ) : (
              text
            )}
          </li>
        ))}
      </ol>
    </nav>
  );

Breadcrumb.defaultProps = {
  crumbs: [],
};

export default Breadcrumb;
